export default __webpack_public_path__ + "static/media/photo--lg--gwen.69a8bb7a.jpg";